/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Page} from '../components';
import {RelaySettingLecture, RelaySettingChannel} from '../components/relaySetting';
import '../css/page/RelaySettingPage.css';

class RelaySettingPage extends Component {
    componentWillMount() {
        document.title = '转载设置';
        const {id} = this.props.params;
        this.props.dispatch({type: 'RELAY_SETTING_ID_INIT', payload: parseInt(id, 10)});
    }

    render() {
        const {type} = this.props.params;
        return (
            <Page>
                <div className="wk-inner-page">
                    {type === 'lecture' &&
                        <RelaySettingLecture/>
                    }

                    {type === 'channel' &&
                        <RelaySettingChannel/>
                    }
                </div>
            </Page>
        )
    }
}


export default connect((state) => ({}))(RelaySettingPage)



// WEBPACK FOOTER //
// ./src/pages/RelaySettingPage.js